import { DE, AU, NL } from "country-flag-icons/react/3x2";

export const languages = [
  {
    name: "language_de",
    level: 6,
    levelKey: "language_level_native",
    code: "DE",
    flag: DE,
  },
  {
    name: "language_en",
    level: 5,
    levelKey: "language_level_c1",
    code: "EN",
    flag: AU,
  },
  {
    name: "language_nl",
    level: 2,
    levelKey: "language_level_a2",
    code: "NL",
    flag: NL,
  },
];
